import * as PIXI from "pixi.js";
import { TimeCountManager } from "../managers/timeCountManager";
import { setupTimeCounter } from "../actors/timeCounter";
import { loadHeartAssets } from "../actors/heart";
import { HeartManager } from "../managers/heartManager";

type SetupStageUIProps = Readonly<{
  heartAssets: ReturnType<typeof loadHeartAssets>;
  parent: PIXI.Container;
  ticker: PIXI.Ticker;
  timeCountManager: TimeCountManager;
  heartManager: HeartManager;
}>;
export function setupStageUI({
  heartAssets,
  parent,
  ticker,
  timeCountManager,
  heartManager,
}: SetupStageUIProps) {
  const uiContainer = new PIXI.Container();
  const disposeCounter = setupTimeCounter({
    parent: uiContainer,
    ticker,
    timeCountManager,
    textStyle: new PIXI.TextStyle({
      fontFamily: "Comfortaa",
      fontSize: 20,
      align: "center",
      wordWrapWidth: 1000,
      wordWrap: true,
    }),
    x: 550,
    y: 20,
  });

  const hearts: Array<() => void> = [];
  let num = 0;
  const onTick = () => {
    if (num < heartManager.num) {
      const heart = new PIXI.Sprite(heartAssets.heart.get());
      heart.width = 20;
      heart.height = 20;
      heart.y = 20;
      heart.x = 40 + num * 30;
      uiContainer.addChild(heart);
      hearts.push(() => uiContainer.removeChild(heart));
      num++;
    } else if (num > heartManager.num) {
      hearts.pop()?.();
      num--;
    }
  };

  parent.addChild(uiContainer);
  ticker.add(onTick);
  const dispose = () => {
    disposeCounter();
    parent.removeChild(uiContainer);
    ticker.remove(onTick);
  };
  return dispose;
}
